import {
  DownloadException,
} from '@/domain/download/repository/exception/DownloadException'

export class CouldNotGetAvailableApplications extends DownloadException {

}
